import React from 'react'

// Parse an array of strings to a sentance with bold words.
// input: ['Soft Caresses', 'Grinding', 'Kissing with Lots of Tongue']
// output: <b>Soft Caresses</b>, <b>Grinding</b> and <b>Kissing with Lots of Tongue</b>
export const boldWords = (words: string[]) => {
  // Use splice so the last item is not rendered in the html twice, clone it to
  // prevent unwanted mutation.
  const wordsCopy = [...words]
  const lastWord = wordsCopy.splice(words.length - 1)[0]
  return (
    <>
      {wordsCopy.map((w, index) => (
        <React.Fragment key={`${w}-${index}`}>
          <b>{w}</b>
          {index === wordsCopy.length - 1 ? <> and </> : <>, </>}
        </React.Fragment>
      ))}
      <b>{lastWord}</b>
    </>
  )
}
